import script from "./dashboardLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboardLayout.vue?vue&type=script&setup=true&lang=js"

import "./dashboardLayout.vue?vue&type=style&index=0&id=008dc90e&lang=scss"

const __exports__ = script;

export default __exports__